import { render } from "./TwoFaAuthSuccess.vue?vue&type=template&id=7b46dfec&scoped=true&ts=true"
import script from "./TwoFaAuthSuccess.vue?vue&type=script&lang=ts"
export * from "./TwoFaAuthSuccess.vue?vue&type=script&lang=ts"

import "./TwoFaAuthSuccess.vue?vue&type=style&index=0&id=7b46dfec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b46dfec"]])

export default __exports__